import "./styles/App.scss";

import MapView from "./components/MapView/MapView";
import SearchView from "./components/SearchView/SearchView";
import ListModal from "./components/ListModal/ListModal";
import ViewToggle from "./components/ViewToggle/ViewToggle";
import { useSearchStore } from "./store/searchStore";

function App() {
  // Drives the mobile map/list switch. App.scss only reads this below the xl
  // breakpoint; above it both panes are always shown.
  const activeView = useSearchStore((s) => s.activeView);

  return (
    <main>
      <div id="appContainer" data-view={activeView}>
        <MapView />
        <SearchView />
      </div>
      <ViewToggle />
      <ListModal />
    </main>
  );
}

export default App;
